import { gql } from '@apollo/client';

export const TRACK_LOGIN_EVENT = gql`
  mutation TrackLoginEvent($input: TrackLoginEventInput!) {
    trackLoginEvent(input: $input) {
      id
      success
      message
    }
  }
`;
